/**
 * Event History tab (spec section 59).
 *
 * Bear participation is already visible on the Bear tab. The remaining event
 * types — Fortress, Sanctuary, Castle, AC, Swordland, Viking — have no recorded
 * results yet because their recording surfaces land in later phases, so this
 * lists what will appear here rather than showing an empty table that implies
 * the player simply did not attend.
 *
 * The notice at the top is spec section 50 stated out loud: this record exists
 * to staff operations, not to rank people. Both locales say so in the same
 * plain terms, and neither uses blame vocabulary for absence.
 */

import { Link } from 'react-router-dom';
import { Card, Notice } from '../../../components/ui/primitives';
import { eventTypeLabel } from '../../../lib/enumLabels';
import { useT } from '../../../i18n';

const PENDING_EVENT_TYPES = [
  'FORTRESS',
  'SANCTUARY',
  'CASTLE',
  'ALLIANCE_CHAMPIONSHIP',
  'SWORDLAND',
  'VIKING_VENGEANCE',
] as const;

export function EventHistoryTab() {
  const t = useT();

  return (
    <div className="stack">
      <Notice severity="INFO">{t.eventHistory.notice}</Notice>

      <Card title={t.eventHistory.bearTitle}>
        <p className="muted small" style={{ margin: 0 }}>
          {t.eventHistory.bearBody} <strong>{t.eventHistory.bearTabName}</strong>{' '}
          {t.eventHistory.bearBodyTail}
        </p>
      </Card>

      <Card title={t.eventHistory.otherTitle}>
        <p className="muted small" style={{ marginTop: 0 }}>
          {t.eventHistory.otherBody}
        </p>
        <ul className="small muted" style={{ margin: 0, paddingLeft: 18 }}>
          {PENDING_EVENT_TYPES.map((type) => (
            <li key={type}>{eventTypeLabel(t, type)}</li>
          ))}
        </ul>
        <p className="faint small" style={{ marginBottom: 0, marginTop: 8 }}>
          {t.eventHistory.seeEvents}{' '}
          <Link to="/events/fortress">{t.eventHistory.seeEventsLink}</Link>
          {t.eventHistory.seeEventsTail}
        </p>
      </Card>
    </div>
  );
}
